import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import generalActions from 'redux/actions/generalActions'

import MediaPreview from 'components/media_preview/media_preview'
import styles from './media_preview_container.scss'

class mediaPreviewContainer extends PureComponent {

	constructor() {
		super()
		this.closeModal = this.closeModal.bind(this)
	}

	closeModal() {
		this.props.actions.closeModal(this.props.modalName)
	}

	render() {
		return (
			<MediaPreview
				onClose={this.closeModal}
				mediaType={this.props.mediaType}
				mediaVersions={this.props.mediaVersions}
			/>
		)
	}
}

mediaPreviewContainer.propTypes = {
	mediaType: PropTypes.string,
	mediaVersions: PropTypes.object,
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(CSSModules(mediaPreviewContainer, styles, {allowMultiple: true}))
